import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 公開日時
 */
export class PublishDatetime extends PrimitiveValueObjectDateTime {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: Date): PublishDatetime {
    return new PublishDatetime(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '掲載日時';
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    const d = this.value;
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 ${d.getHours()}時${d.getMinutes()}分`;
  }

  /**
   * ホームページ時間生成
   * @returns 時間
   */
  toStringForHomepage(): string {
    const date = this.value;
    const y = date.getFullYear();
    const mon = (`00${date.getMonth() + 1}`).slice(-2);
    const d = (`00${date.getDate()}`).slice(-2);
    const ymd = `${y}${mon}${d}`;
    const h = (`00${date.getHours()}`).slice(-2);
    const m = (`00${date.getMinutes()}`).slice(-2);
    const s = (`00${date.getSeconds()}`).slice(-2);
    const hms = `${h}${m}${s}`;
    const milli = (`000${date.getTime() % 1000}`).slice(-3);
    return `${ymd}T${hms}${milli}Z`;
  }
}
